import createArray from './createArray'

const B = 0.552284749831

const slope = ([x1, y1], [x2, y2]) =>
    (Math.atan2(y1 - y2, x1 - x2) * 180) / Math.PI

const arc = (p1, p2) => {
    const s = slope(p1, p2)
    const [x1, y1] = p1
    const [x2, y2] = p2
    const r = Math.abs(x1 - x2) * B

    return s <= -90
        ? [p1, [x1 + r, y1], [x2, y2 - r], p2]
        : s < 0
        ? [p1, [x1, y1 + r], [x2 + r, y2], p2]
        : s === 0
        ? [p1, p1, p2, p2]
        : s <= 90
        ? [p1, [x1 - r, y1], [x2, y2 + r], p2]
        : s < 180
        ? [p1, [x1, y1 - r], [x2 - r, y2], p2]
        : [p1, p1, p2, p2]
}

const getPoints = (x, y, W) => {
    const R = W / 3
    const RS = R / 2
    const P1 = [x + 0, y + 0]
    const P2 = [x + R, y + 0]
    const P3 = [x + R * 2, y + 0]
    const P4 = [x + W, y + 0]
    const P5 = [x + 0, y + R]
    const P6 = [x + W, y + R]
    const P7 = [x + 0, y + R * 2]
    const P8 = [x + W, y + R * 2]
    const P9 = [x + 0, y + W]
    const P10 = [x + R, y + W]
    const P11 = [x + R * 2, y + W]
    const P12 = [x + W, y + W]
    const PT = [x + W / 2, y + -RS]
    const PB = [x + W / 2, y + W + RS]
    const PL = [x + -RS, y + W / 2]
    const PR = [x + W + RS, y + W / 2]
    return {
        P1,
        P2,
        P3,
        P4,
        P5,
        P6,
        P7,
        P8,
        P9,
        P10,
        P11,
        P12,
        PT,
        PB,
        PL,
        PR,
        CT: [
            arc(PT, P3),
            arc(P3, [x + W / 2, y + RS]),
            arc([x + W / 2, y + RS], P2),
            arc(P2, PT),
        ],
        CB: [
            arc(PB, P10),
            arc(P10, [x + W / 2, y + W - RS]),
            arc([x + W / 2, y + W - RS], P11),
            arc(P11, PB),
        ],
        CL: [
            arc(PL, P5),
            arc(P5, [x + RS, y + W / 2]),
            arc([x + RS, y + W / 2], P7),
            arc(P7, PL),
        ],
        CR: [
            arc(PR, P8),
            arc(P8, [x + W - RS, y + W / 2]),
            arc([x + W - RS, y + W / 2], P6),
            arc(P6, PR),
        ],
    }
}

const pattern1 = (x, y, w) => {
    const p = getPoints(x, y, w)
    const PA1 = [
        arc(p.P5, p.P11),
        arc(p.P11, p.PB),
        arc(p.PB, p.P10),
        arc(p.P7, p.P10).reverse(),
        arc(p.P7, p.PL),
        arc(p.PL, p.P5),
    ]

    const PA2 = [
        arc(p.P6, p.P3).reverse(),
        arc(p.P6, p.PR),
        arc(p.PR, p.P8),
        arc(p.P8, p.P2),
        arc(p.P2, p.PT),
        arc(p.PT, p.P3),
    ]
    return [PA1.reduce(addCurve, ''), PA2.reduce(addCurve, '')]
}
const pattern2 = (x, y, w) => {
    const p = getPoints(x, y, w)

    const PA3 = [
        arc(p.P3, p.P7),
        arc(p.P7, p.PL),
        arc(p.PL, p.P5),
        arc(p.P2, p.P5).reverse(),
        arc(p.P2, p.PT),
        arc(p.PT, p.P3),
    ]
    const PA4 = [
        arc(p.P10, p.P6),
        arc(p.P6, p.PR),
        arc(p.PR, p.P8),
        arc(p.P11, p.P8).reverse(),
        arc(p.P11, p.PB),
        arc(p.PB, p.P10),
    ]
    return [PA3.reduce(addCurve, ''), PA4.reduce(addCurve, '')]
}

const pattern7 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        [
            arc(p.PT, p.P3),
            arc(p.P3, p.P11),
            arc(p.P11, p.PB),
            arc(p.PB, p.P10),
            arc(p.P10, p.P2),
            arc(p.P2, p.PT),
        ].reduce(addCurve, ''),
        [
            arc(p.PL, p.P5),
            arc(p.P5, p.P6),
            arc(p.P6, p.PR),
            arc(p.PR, p.P8),
            arc(p.P8, p.P7),
            arc(p.P7, p.PL),
        ].reduce(addCurve, ''),
    ]
}

const pattern3 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CB.reduce(addCurve, ''),
        p.CT.reduce(addCurve, ''),
        [
            arc(p.PL, p.P5),
            arc(p.P5, p.P6),
            arc(p.P6, p.PR),
            arc(p.PR, p.P8),
            arc(p.P8, p.P7),
            arc(p.P7, p.PL),
        ].reduce(addCurve, ''),
    ]
}
const pattern4 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CR.reduce(addCurve, ''),
        p.CL.reduce(addCurve, ''),
        [
            arc(p.PT, p.P3),
            arc(p.P3, p.P11),
            arc(p.P11, p.PB),
            arc(p.PB, p.P10),
            arc(p.P10, p.P2),
            arc(p.P2, p.PT),
        ].reduce(addCurve, ''),
    ]
}
const pattern5 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CR.reduce(addCurve, ''),
        p.CL.reduce(addCurve, ''),
        p.CB.reduce(addCurve, ''),
        p.CT.reduce(addCurve, ''),
    ]
}
const pattern6 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        [
            arc(p.PT, p.P3),
            arc(p.P6, p.P3).reverse(),
            arc(p.P6, p.PR),
            arc(p.PR, p.P8),
            arc(p.P11, p.P8).reverse(),
            arc(p.P11, p.PB),
            arc(p.PB, p.P10),
            arc(p.P7, p.P10).reverse(),
            arc(p.P7, p.PL),
            arc(p.PL, p.P5),
            arc(p.P2, p.P5).reverse(),
            arc(p.P2, p.PT),
        ].reduce(addCurve, ''),
    ]
}

const pattern8 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CL.reduce(addCurve, ''),
        p.CB.reduce(addCurve, ''),
        [
            arc(p.P6, p.P3).reverse(),
            arc(p.P6, p.PR),
            arc(p.PR, p.P8),
            arc(p.P8, p.P2),
            arc(p.P2, p.PT),
            arc(p.PT, p.P3),
        ].reduce(addCurve, ''),
    ]
}

const pattern9 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CR.reduce(addCurve, ''),
        p.CT.reduce(addCurve, ''),
        [
            arc(p.P5, p.P11),
            arc(p.P11, p.PB),
            arc(p.PB, p.P10),
            arc(p.P7, p.P10).reverse(),
            arc(p.P7, p.PL),
            arc(p.PL, p.P5),
        ].reduce(addCurve, ''),
    ]
}

const pattern10 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CR.reduce(addCurve, ''),
        p.CB.reduce(addCurve, ''),
        [
            arc(p.P3, p.P7),
            arc(p.P7, p.PL),
            arc(p.PL, p.P5),
            arc(p.P2, p.P5).reverse(),
            arc(p.P2, p.PT),
            arc(p.PT, p.P3),
        ].reduce(addCurve, ''),
    ]
}

const patter11 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CL.reduce(addCurve, ''),
        p.CT.reduce(addCurve, ''),
        [
            arc(p.P10, p.P6),
            arc(p.P6, p.PR),
            arc(p.PR, p.P8),
            arc(p.P11, p.P8).reverse(),
            arc(p.P11, p.PB),
            arc(p.PB, p.P10),
        ].reduce(addCurve, ''),
    ]
}

const pattern12 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CB.reduce(addCurve, ''),
        [
            arc(p.PT, p.P3),
            arc(p.P6, p.P3).reverse(),
            arc(p.P6, p.PR),
            arc(p.PR, p.P8),
            arc(p.P8, p.P7),
            arc(p.P7, p.PL),
            arc(p.PL, p.P5),
            arc(p.P2, p.P5).reverse(),
            arc(p.P2, p.PT),
        ].reduce(addCurve, ''),
    ]
}
const pattern13 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CT.reduce(addCurve, ''),
        [
            arc(p.P6, p.PR),
            arc(p.PR, p.P8),
            arc(p.P11, p.P8).reverse(),
            arc(p.P11, p.PB),
            arc(p.PB, p.P10),
            arc(p.P7, p.P10).reverse(),
            arc(p.P7, p.PL),
            arc(p.PL, p.P5),
            arc(p.P5, p.P6),
        ].reduce(addCurve, ''),
    ]
}
const pattern14 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CL.reduce(addCurve, ''),
        [
            arc(p.PT, p.P3),
            arc(p.P6, p.P3).reverse(),
            arc(p.P6, p.PR),
            arc(p.PR, p.P8),
            arc(p.P11, p.P8).reverse(),
            arc(p.P11, p.PB),
            arc(p.PB, p.P10),
            arc(p.P10, p.P2),
            arc(p.P2, p.PT),
        ].reduce(addCurve, ''),
    ]
}
const pattern15 = (x, y, w) => {
    const p = getPoints(x, y, w)
    return [
        p.CR.reduce(addCurve, ''),
        [
            arc(p.PT, p.P3),
            arc(p.P3, p.P11),
            arc(p.P11, p.PB),
            arc(p.PB, p.P10),
            arc(p.P7, p.P10).reverse(),
            arc(p.P7, p.PL),
            arc(p.PL, p.P5),
            arc(p.P2, p.P5).reverse(),
            arc(p.P2, p.PT),
        ].reduce(addCurve, ''),
    ]
}
const bg = (x, y, w) => {
    const r = w / 3
    const rs = r / 2
    const p = getPoints(x, y, w)
    return [
        arc(p.P5, [x - r, y]),
        arc([x - r, y], [x, y - r]),
        arc([x, y - r], p.P2),
        arc([x + w / 2, y + rs], p.P2).reverse(),
        arc(p.P3, [x + w / 2, y + rs]).reverse(),
        arc(p.P3, [x + w, y - r]),
        arc([x + w, y - r], [x + w + r, y]),
        arc([x + w + r, y], p.P6),
        arc([x + w - rs, y + w / 2], p.P6).reverse(),
        arc(p.P8, [x + w - rs, y + w / 2]).reverse(),
        arc(p.P8, [x + w + r, y + w]),
        arc([x + w + r, y + w], [x + w, y + w + r]),
        arc([x + w, y + w + r], p.P11),
        arc([x + w / 2, y + w - rs], p.P11).reverse(),
        arc(p.P10, [x + w / 2, y + w - rs]).reverse(),
        arc(p.P10, [x + r, y + w]),
        arc([x + r, y + w], [x, y + w + r]),
        arc([x, y + w + r], [x - r, y + w]),
        arc([x - r, y + w], p.P7),
        arc([x + rs, y + w / 2], p.P7).reverse(),
        arc(p.P5, [x + rs, y + w / 2]).reverse(),
    ].reduce(addCurve, '')
}

export const pattern = {
    p1: pattern1,
    p2: pattern2,
    p3: pattern3,
    p4: pattern4,
    p5: pattern5,
    p6: pattern6,
    p7: pattern7,
    p8: pattern8,
    p9: pattern9,
    p10: pattern10,
    p11: patter11,
    p12: pattern12,
    p13: pattern13,
    p14: pattern14,
    p15: pattern15,
}

// const pattern = [pattern15]

const addCurve = (acc, [p1, p2, p3, p4]) =>
    // prettier-ignore
    `${acc} ${acc === '' ? `M ${p1[0]} ${p1[1]}` : ''} C ${p2[0]} ${p2[1]}, ${ p3[0] } ${p3[1]}, ${p4[0]} ${p4[1]} `

export const truchet = ({
    x = 0,
    y = 0,
    size,
    depth = 0,
    cnt,
    width,
    maxDepth,
    simplex,
    noiseRatioX,
    noiseRatioY,
    noiseFormRatioX,
    noiseFormRatioY,
    seed,
    pattern,
    goSmallerRatio = 1,
    colors = ['#4B1139', '#FFCA4F', '#FF9C2B', '#FF622E', '#FF3D3D'],
}) =>
    pattern.length === 0
        ? []
        : createArray((i) => {
              const _x = (i % width) * size
              const _y = Math.floor(i / width) * size
              const newX = _x + x
              const newY = _y + y
              const n = simplex.noise2D(
                  (newX + 1) / noiseRatioX,
                  (newY + 1) / noiseRatioY
              )
              const color = [
                  colors[Math.floor(Math.abs(n) * colors.length)],
                  'white',
              ][depth % 2]
              const bgcolor = [
                  'white',
                  colors[Math.floor(Math.abs(n) * colors.length)],
              ][depth % 2]

              if (
                  depth == maxDepth ||
                  Math.abs(
                      simplex.noise2D(
                          (newX + 1) / noiseFormRatioY,
                          (newY + 1) / noiseFormRatioX
                      )
                  ) <
                      depth / maxDepth / goSmallerRatio
              ) {
                  const background = bg(newX, newY, size)

                  const d = pattern[
                      Math.round(
                          Math.abs(
                              simplex.noise2D(
                                  1 + newY / noiseFormRatioY,
                                  1 + newX / noiseFormRatioX
                              ) * pattern.length
                          )
                      ) % pattern.length
                  ](newX, newY, size)
                  return {
                      d,
                      color,
                      bgcolor,
                      x: newX,
                      y: newY,
                      _x: x + size,
                      _y: y + size,
                      size,
                      background,
                      depth,
                      goSmallerRatio,
                  }
              }

              return truchet({
                  x: newX,
                  y: newY,
                  size: size / 2,
                  depth: depth + 1,
                  cnt: 4,
                  width: 2,
                  maxDepth,
                  simplex,
                  noiseRatioX,
                  noiseRatioY,
                  noiseFormRatioX,
                  noiseFormRatioY,
                  seed,
                  pattern,
                  colors,
              })
          }, cnt)
